// Lumi web client entry point. JavaScript is required to use Lumi.
import '@lumi/shared/design-tokens.css';
import './styles.css';
import { createApp } from './app.js';
import { applyTextSize } from './ui/text-size.js';
import { applyLanguage, detectLanguage } from './i18n.js';

// Restore the reader's chosen chat size before anything draws, so a returning
// user never sees a flash of the small default and then a jump.
applyTextSize();

// And the language, for the same reason and one more: applyLanguage sets `lang`
// and `dir` on the document, so a right-to-left language has to be settled
// before the first element is laid out, not after.
applyLanguage(detectLanguage());

const root = document.getElementById('app');
const app = createApp(root);
app.showLanding();
